import type { Dayjs } from 'dayjs';
import r3Icon from './assets/FenoSoja-R3.svg?raw';
import r4Icon from './assets/FenoSoja-R4.svg?raw';
import r5Icon from './assets/FenoSoja-R5.svg?raw';
import r1Icon from './assets/MaizCP_R1.svg?raw';
import SeedIcon from './assets/MaizCP_semilla.svg?raw';
import EmergenceIcon from './assets/MaizCP_V.svg?raw';
import v1Icon from './assets/MaizCP_V1.svg?raw';
import v2Icon from './assets/MaizCP_V2.svg?raw';
import v3Icon from './assets/MaizCP_V3.svg?raw';
import v4Icon from './assets/MaizCP_V4.svg?raw';
import v5Icon from './assets/MaizCP_V5.svg?raw';
import v6Icon from './assets/MaizCP_V6.svg?raw';
import v7Icon from './assets/MaizCP_V7.svg?raw';
import v8Icon from './assets/MaizCP_V8.svg?raw';
import v9Icon from './assets/MaizCP_V9.svg?raw';
import v10Icon from './assets/MaizCP_V10.svg?raw';
import SoyBeanIcon from './assets/SojaCP_grano.svg?raw';
import SoyV1Icon from './assets/SojaCP_V1.svg?raw';
import SoyV2Icon from './assets/SojaCP_V2.svg?raw';
import SoyVcIcon from './assets/SojaCP_VC.svg?raw';
import WheatEmergenceIcon from './assets/TrigoCP_emergencia.svg?raw';
import WheatStemElongationIcon from './assets/TrigoCP_encanazon.svg?raw';
import WheatHeadingIcon from './assets/TrigoCP_espigazon.svg?raw';
import WheatGerminationIcon from './assets/TrigoCP_germinacion.svg?raw';
import WheatFlagLeafIcon from './assets/TrigoCP_hoja_bandera.svg?raw';
import WheatSeedIcon from './assets/TrigoCP_semilla.svg?raw';

export const PhenologiesIcons = {
    seed: SeedIcon,
    emergence: EmergenceIcon,
    v1: v1Icon,
    v2: v2Icon,
    v3: v3Icon,
    v4: v4Icon,
    v5: v5Icon,
    v6: v6Icon,
    v7: v7Icon,
    v8: v8Icon,
    v9: v9Icon,
    v10: v10Icon,
    r1: r1Icon,
    r3: r3Icon,
    r4: r4Icon,
    r5: r5Icon,
    wheat_seed: WheatSeedIcon,
    wheat_germination: WheatGerminationIcon,
    wheat_emergence: WheatEmergenceIcon,
    wheat_stem_elongation: WheatStemElongationIcon,
    wheat_flag_leaf: WheatFlagLeafIcon,
    wheat_heading: WheatHeadingIcon,
    soy_bean: SoyBeanIcon,
    soy_vc: SoyVcIcon,
    soy_v1: SoyV1Icon,
    soy_v2: SoyV2Icon,
};

export type PhenologyIconKey = keyof typeof PhenologiesIcons;

export const PLANTING_PHENOLOGY_ICONS: PhenologyIconKey[] = ['seed', 'wheat_seed', 'soy_bean'];

/** Blue timeline bar overlaps icons; planting icons need offset (others use 30px). */
export const PHENOLOGY_TIMELINE_BAR_OFFSET = 36;

export const getPhenologyIconMarginBottom = (icon: PhenologyIconKey, disabled: boolean) => {
    if (disabled) return undefined;
    if (PLANTING_PHENOLOGY_ICONS.includes(icon)) return `${PHENOLOGY_TIMELINE_BAR_OFFSET}px`;
    return '30px';
};

export type CPType = 'weeds' | 'plagues' | 'diseases' | 'seed_treatment';

export type Option = {
    comments: string;
    type: CPType | 'weed' | 'plague';
    columns: Array<{
        name: string;
        condition: string;
        products: Array<{
            dose: string;
            name: string;
            image: string;
        }>;
    }>;
};

export type CropProtectionMonth = {
    name?: string;
    disabled: boolean;
    icons?: Array<PhenologyIconKey>;
    columns?: Option['columns'];
    iconsDescriptions?: Array<string>;
};

export type GetMonth = ({
    createdDate,
    plantingDate,
    option,
    applicationWindow,
    crop,
}: {
    createdDate: Date;
    plantingDate?: Date;
    option: Option;
    applicationWindow?: 'v2_to_v10' | 'v1_to_v8';
    crop?: string;
}) => Array<{
    name?: string;
    disabled: boolean;
    icons?: Array<PhenologyIconKey>;
    columns?: Option['columns'];
    iconsDescriptions?: Array<string>;
}>;

export type ApplicationOptionType = {
    title: (params?: { crop?: string }) => string;
    description: ({ type }: { type?: string }) => string;
    disabled: ({ plantingDate }: { plantingDate?: Date }) => boolean;
    getMonths: GetMonth;
};

export type CropProtectionForm = {
    fieldId: number;
    crop?: 'corn' | 'soy' | 'wheat' | 'barley' | '';
    plantingDate?: Dayjs | '';
    type: 'weeds' | 'plagues' | 'diseases' | 'seed_treatment' | '';
    application: string;
    weedType: number | '';
    weed: number | '';
    weedSize: number | '';
    recommendationOption: number | '';
    diseaseId: number | '';
    applicationType: 'healing' | 'preventive' | '';
    plagueId: number | '';
};
